export default __webpack_public_path__ + "static/media/MercaZCali.22c05f15.geojson";